import React from 'react';
import styled from 'styled-components';

import bloomberg from '../assets/sponsors/bloomberg.png';
import cybersource from '../assets/sponsors/cybersource.png';
import figma from '../assets/sponsors/figma.png';
import microsoft from '../assets/sponsors/microsoft.png';
import slalom from '../assets/sponsors/slalom.png';
import gather from '../assets/sponsors/gather.png';
import panopto from '../assets/sponsors/panopto.png';
import facebook from '../assets/sponsors/facebook.png';
import { DesktopOnly } from './DesktopOnly';
import { MobileOnly } from './MobileOnly';

const Container = styled.div`
  display: flex;
  flex-flow: column nowrap;
  width: 100%;

  justify-content: flex-start;
  align-items: center;
`;

const Row = styled.div`
  display: flex;
  flex-flow: row nowrap;
  flex-grow: 0;
  margin-bottom: 20px;

  justify-content: center;
  align-items: center;
`;

const SponsorImage = styled.img<{ width: number }>`
  width: ${({ width }) => width}%;
  max-height: 200px;
  padding: 0 20px 20px 20px;
`;

export const Sponsors: React.FC = () => {
  return (
    <Container>
      <DesktopOnly>
        <Row>
          <SponsorImage src={bloomberg} alt="Bloomberg" width={20} />
          <SponsorImage src={slalom} alt="slalom_build" width={8} />
          <SponsorImage src={figma} alt="Figma" width={10} />
        </Row>
        <Row>
          <SponsorImage src={gather} alt="Gather" width={20} />
          <SponsorImage src={panopto} alt="Panopto" width={25} />
        </Row>
        <Row>
          <SponsorImage src={facebook} alt="Facebook" width={40} />
        </Row>
      </DesktopOnly>
      <MobileOnly>
        <Row>
          <SponsorImage src={bloomberg} alt="Bloomberg" width={50} />
          <SponsorImage src={slalom} alt="slalom_build" width={20} />
        </Row>
        <Row>
          <SponsorImage src={figma} alt="Figma" width={25} />
          <SponsorImage src={gather} alt="Gather" width={50} />
        </Row>
        <Row>
          <SponsorImage src={panopto} alt="Panopto" width={50} />
        </Row>
        <Row>
          <SponsorImage src={facebook} alt="Facebook" width={60} />
        </Row>
      </MobileOnly>
    </Container>
  );
};

export const TitleSponsors: React.FC = () => {
  return (
    <Container>
      <DesktopOnly>
        <Row>
          <SponsorImage src={cybersource} alt="Cybersource" width={20} />
          <SponsorImage src={microsoft} alt="Microsoft" width={60} />
        </Row>
      </DesktopOnly>
      <MobileOnly>
        <Row>
          <SponsorImage src={cybersource} alt="Cybersource" width={30} />
          <SponsorImage src={microsoft} alt="Microsoft" width={70} />
        </Row>
      </MobileOnly>
    </Container>
  );
};
